module.exports = false;
try {
  module.exports = self instanceof WorkerGlobalScope
} catch(e) {}


//////////////////
// WEBPACK FOOTER
// ./~/detect-webworker/index.js
// module id = 53
// module chunks = 0